import {Grid, Box, styled, Typography} from "@mui/material";

export const MainGridContainer = styled(Grid)(({ theme }) => ({
  textAlign: 'center',
  minHeight: 'calc(100vh - 170px)',
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'center',
  alignItems: 'center',
  background: "#FFFFFF",
  [theme.breakpoints.down('lg')]: {
    minHeight: '73vh',
  }
}));

export const MainGridContainerItemLeft = styled(Grid)(({ theme }) => ({
  background: "linear-gradient(180deg, #F8F9FC 0%, #F4F6FB 100%)",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
  display: "flex",
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    width: "320px",
    height: "320px",
    left: "-110px",
    top: "-110px",
    background: "radial-gradient(circle, rgba(255, 177, 129, 0.35) 0%, rgba(255, 177, 129, 0) 70%)",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    width: "220px",
    height: "220px",
    right: "72px",
    bottom: "36px",
    borderRadius: "36px",
    border: "1px solid rgba(52, 90, 140, 0.06)",
    background: "rgba(255, 255, 255, 0.18)",
    transform: "rotate(16deg)",
    boxShadow: "0 28px 60px rgba(34, 52, 90, 0.05)",
    backdropFilter: "blur(8px)",
  },
}));

export const MainGridContainerItemRight = styled(Grid)(({ theme }) => ({
  // background: '#E5E5E5'
}));

export const MainGridContainerItemRightBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  overflowY: "auto",
  width: "100%",
  minHeight: "calc(100vh - 172px)",
  [theme.breakpoints.down('lg')]: {
    justifyContent: "inherit",
    marginTop: theme.spacing(2),
    minHeight: "auto",
  }
}));


export const MainGridContainerItemLeftBox = styled(Box)(({ theme }) => ({
  maxWidth: "520px",
  display: 'flex',
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  margin: '0 auto',
  padding: '0 36px',
  height: 'calc(100vh - 172px)',
  position: "relative",
  zIndex: 1,
}));

export const StyledTitle = styled(Typography)(() => ({
  color: "#1C1B1C",
  fontSize: "34px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "1.15",
  textAlign: "left",
  fontFamily: 'Poppins',
  maxWidth: "430px",
}));